import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as initActions from '../../../actions/initActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as animationHelper from "../../../helpers/animationHelper";
import Option from './ResourcesMenuOption';

export class ResourcesMenu extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            menuData: this.props.menuData,
            userData: this.props.userData,
            currentSelection: this.props.currentSelection,
            canClickMenu: true,
            isOpen: false,
            allowStateUpdates: true,
            currentFocus: this.props.menuData[0]
        };

        this.onSelect = this.onSelect.bind(this);
        this.checkIsActive = this.checkIsActive.bind(this);
        this.handleMenu = this.handleMenu.bind(this);
        this.showMenu = this.showMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        this.onMenuHandledComplete = this.onMenuHandledComplete.bind(this);
        this.onMenuOpenComplete = this.onMenuOpenComplete.bind(this);
        this.onMenuCloseComplete = this.onMenuCloseComplete.bind(this);
        this.getLocale = this.getLocale.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setOptionItemClass = this.setOptionItemClass.bind(this);
        this.getPreviousOption = this.getPreviousOption.bind(this);
        this.getNextOption = this.getNextOption.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.setKeyboardNavigationControls = this.setKeyboardNavigationControls.bind(this);


        this.menu = React.createRef();
        this.rotator = React.createRef();
        this.resourceMenuBtn = React.createRef();
        this.menuList = React.createRef();
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        this.setState({currentSelection: Object.assign({}, nextProps.currentSelection)});

        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
    }

    checkIsActive(id) {
        if (id === this.state.currentFocus[this.props.idKey]) {
            return 'active';
        } else {
            return "";
        }
    }

    onSelect(data) {
        this.props.onMenuSelect(data);
        this.hideMenu();
    }

    handleMenu(event) {
        event.stopPropagation();
        if (this.state.canClickMenu) {
            if (this.state.menuIsOpen) {
                this.hideMenu();
            } else {
                this.showMenu();
            }
        }
    }

    hideMenu() {

        if (this.state.menuIsOpen) {
            let rotator = this.rotator.current;
            let rotatorParams = {
                ele: rotator,
                duration: objectConstants.DROPDOWN_MENU_CLOSE_DURATION,
                delay: 0,
                callback: this.onMenuHandledComplete
            };
            animationHelper.rotate180(rotatorParams);
        }

        this.setState({menuIsOpen: false, canClickMenu: false});

        let mainMenu = this.menu.current;
        let hideParams = {
            ele: mainMenu,
            duration: objectConstants.DROPDOWN_MENU_CLOSE_DURATION,
            delay: 0,
            callback: this.onMenuCloseComplete
        };
        animationHelper.hideHeight(hideParams);
    }

    showMenu() {
        this.setState({menuIsOpen: true, canClickMenu: false});
        let mainMenu = this.menu.current;
        let rotator = this.rotator.current;

        let rotatorParams = {
            ele: rotator,
            duration: objectConstants.DROPDOWN_MENU_OPEN_DURATION,
            delay: 0,
            callback: this.onMenuHandledComplete
        };
        animationHelper.rotate180(rotatorParams);

        let showParams = {
            ele: mainMenu,
            duration: objectConstants.DROPDOWN_MENU_OPEN_DURATION,
            delay: 0,
            callback: this.onMenuOpenComplete
        };
        animationHelper.showHeight(showParams);
    }

    onMenuHandledComplete() {
        if (this.state.allowStateUpdates) {
            this.setState({canClickMenu: true});
        }
    }

    onMenuOpenComplete() {
        let menuList = this.menuList.current;
        //console.log(menuList);
        if(appHelper.isObjectEleDefined(menuList)) {
            menuList.focus();
        }
        //this.setState({currentFocus: this.state.menuData[0]});
    }

    onMenuCloseComplete() {

    }

    getLocale(obj) {
        return appHelper.isDefined(obj) ? appHelper.getLocalData(obj) : {};
    }

    setClass() {
        let className = "";
        let userDataObject = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.currentSelection.screen_id);
        if (appHelper.isDefined(userDataObject)) {
            if (userDataObject.status === objectConstants.STATUS_NOT_STARTED) {
                className += `${objectConstants.CLASS_NOT_STARTED} `;
            } else if (userDataObject.status === objectConstants.STATUS_IN_PROGRESS) {
                className += `${objectConstants.CLASS_IN_PROGRESS} `;
            } else if (userDataObject.status === objectConstants.STATUS_COMPLETE) {
                className += `${objectConstants.CLASS_COMPLETE} `;
            }
        }

        return className;
    }

    setOptionItemClass(nav) {
        return nav.parent_screen_id === null ? "option-item" : "option-item child";
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.stopPropagation();
            event.preventDefault();
            if (this.state.canClickMenu) {
                if (this.state.menuIsOpen) {
                    this.hideMenu();
                } else {
                    this.showMenu();

                }
            }
        }
    }


    getPreviousOption() {
        let currentFocusIndex = appHelper.getArrayObjectIndexByKey(this.state.menuData, "screen_id", this.state.currentFocus.screen_id);
        let prevIndex = currentFocusIndex - 1;

        if (prevIndex < 0) {
            prevIndex = this.state.menuData.length - 1;
        }

        let nextFocus = this.state.menuData[prevIndex];

        this.setState({currentFocus: Object.assign({}, nextFocus)});

    }


    getNextOption() {
        let currentFocusIndex = appHelper.getArrayObjectIndexByKey(this.state.menuData, "screen_id", this.state.currentFocus.screen_id);

        let nextIndex = currentFocusIndex + 1;

        if (nextIndex === this.state.menuData.length) {
            nextIndex = 0;
        }

        let nextFocus = this.state.menuData[nextIndex];

        this.setState({currentFocus: Object.assign({}, nextFocus)});
    }

    setKeyboardNavigationControls(event) {
        event.stopPropagation();
        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.stopPropagation();
            event.preventDefault();
            this.getNextOption();

        }
        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.stopPropagation();
            event.preventDefault();
            this.getPreviousOption();
        }

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.props.onMenuSelect(this.state.currentFocus);
            this.hideMenu();
            let referenceMenuBtn = this.resourceMenuBtn.current;
            if(appHelper.isObjectEleDefined(referenceMenuBtn)){
                referenceMenuBtn.focus();
            }
        }
    }

    render() {

        return (
            <div className="selection-menu resources">
                <div onClick={this.handleMenu} onKeyDown={this.setKeyboardAccessibility} role="button" id="resourceMenuBtn" ref={this.resourceMenuBtn} tabIndex="0" aria-haspopup="true" className="selection-menu-btn">
                    <div className={`selected-title ${this.setClass()}`}
                         id="menuCurrentSelection"> {this.getLocale(this.state.currentSelection).title}</div>
                    <div className="menu-icon">
                        <div ref={this.rotator} className="rotating-icon icons8-circled-arrow-down-filled"/>
                    </div>
                </div>
                <div ref={this.menu} className="menu-option-container">
                    <ul className="menu-option-list" role="listbox" id="menuList"
                        onKeyDown={this.setKeyboardNavigationControls} ref={this.menuList}
                        aria-labelledby="menuCurrentSelection" tabIndex={this.state.menuIsOpen ? 0 : -1}>
                        {this.state.menuData.map(nav =>
                            <li className={`${this.setOptionItemClass(nav)}`} key={nav[this.props.idKey]}>
                                <Option onSelectFunc={this.onSelect}
                                        params={nav}
                                        label={`${this.getLocale(nav).title}`}
                                        activeClass={this.checkIsActive(nav[this.props.idKey])}
                                        activeScreenId={this.state.currentSelection.screen_id}
                                        isOpen={this.state.isOpen}
                                        currentFocus={this.state.currentFocus}
                                />
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        );
    }
}

ResourcesMenu.propTypes = {
    menuData: PropTypes.array,
    currentSelection: PropTypes.object,
    onMenuSelect: PropTypes.func,
    idKey: PropTypes.string,
    labelKey: PropTypes.string,
    userData: PropTypes.object,
    contentData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

//Pull in the React Router context so router is available on this.context.router.
ResourcesMenu.contextTypes = {
    router: PropTypes.object
};

//Init
function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        contentData: state.contentData,
        userData: state.userData,
        lang:lang
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourcesMenu);



/** WEBPACK FOOTER **
 ** ./src/components/dialogs/resources/ResourcesMenu.js
 **/